// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "lib-flexible/flexible.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import { api } from "./view/js/api";

import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);
//
import global from "./Global";
Vue.prototype.GLOBAL = global;
//
import axios from "axios";
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;
// 添加请求拦截器,发送请求之前做些什么
axios.interceptors.request.use(
  config => {
    if (config.url != api + "/login/accountLogin") {
      let token = localStorage.getItem("loginToken"); //判断是否存在token，如果存在将每个页面header都添加token
      if (token) {
        // console.log('-------------设置token')
        // config.headers.token = token;
        config.headers = {
          "x-auth-token": token //
        };
      }
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 添加一个返回拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code == "401") {
      localStorage.removeItem("id");
      localStorage.removeItem("loginToken");
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("name");
      router.push("/");
    }
    return response;
  },
  err => {
    console.log(err);
    return Promise.reject(err);
  }
);
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("id");
  if (to.meta.title) {
    // 动态修改标签页文字 标题文字
    document.title = to.meta.title;
  } // 判断该页面是否需要登录

  if (to.meta.auth) {
    // 如果token存在直接跳转
    if (token) {
      next();
    } else {
      // 否则跳转到login登录页面
      next({
        path: "/", // 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
        query: {}
      });
    }
  } else {
    // 如果不需要登录，则直接跳转到对应页面
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js